import _ from "lodash";
import { API_ROUTES } from "@/constants/apiRoutes";
import { httpRequestServer } from "@/services/httpRequestServer";
import {
  IAnalyticsJob, 
  IAnalyticsJobCreateOptions, 
  ILifetimeMetricsResponse, 
  ISummaryMetricsResponse} from "@/models/analyticsJob.model";
import { TimePeriodType } from "@/models/timePeriod.model";

export const analyticsJobDataService = {
  createAsync: async (request: IAnalyticsJobCreateOptions) : Promise<string> => {
    return await httpRequestServer.post(`${API_ROUTES.ANALYTICS_JOB}/create`, request);
  },

  getAsync: async (jobId: string): Promise<IAnalyticsJob> => {
    return await httpRequestServer.get(`${API_ROUTES.ANALYTICS_JOB}/get/${jobId}`);
  },

  getLifetimeMetricsAsync: async () : Promise<ILifetimeMetricsResponse> => {
    return await httpRequestServer.post(`${API_ROUTES.ANALYTICS_JOB}/life-time-metrics`);
  },

  getSummaryMetricsAsync: async (dateRangeType: TimePeriodType): Promise<ISummaryMetricsResponse> => {
    return await httpRequestServer.post(`${API_ROUTES.ANALYTICS_JOB}/summary-metrics`, { dateRangeType });
  }
};

